import usersController from '../users.controller';

class usersDetailController extends usersController{
  constructor(
    $auth,
    $users,
    $companies,
    $uibModal,
    $stateParams,
    CONFIG
  ){
    'ngInject';
    super( $auth, $users, $companies, $uibModal );

    this.$auth = $auth;

    this.config = {
      id : $stateParams.id
    };

    this.$users.setUri( `${CONFIG.API.users}` );

    this._retrieveUser();
  }

  _retrieveUser(){
    this.$users
      .retrieve( this.config.id )
      .then( user => this.user = user );
  }

  onLangChange($event) {
    this.$auth.changeLang(this.user.lang);
  }


}

export default usersDetailController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-detail/users-detail.controller.js
 **/